'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('external.contact-info', {
    views: {
      'externalContent': {
        component: 'contactInfo',
      }
    }
  })
}



// WEBPACK FOOTER //
// ./client/app/features/contact-info/contact-info.routes.js